import styles from './tableBody.module.css';

const TableBody = ({ data = [], columns = [], setRowClickId }) => {
    return (
        <tbody>
            {data.map((row, rowIndex) => {
                return (
                    <tr
                        key={rowIndex}
                        className={`${styles.tableBodyRow} ${styles.allowCLick}`}
                        onClick={() => {
                            setRowClickId(row._id || row);
                        }}
                    >
                        {columns.map((column, columnIndex) => (
                            <td key={`${column.accessor}-${columnIndex}`}>
                                {column.render
                                    ? column.render(row[column.accessor], row)
                                    : (row[column.accessor] ?? 'N/A')}
                            </td>
                        ))}
                    </tr>
                );
            })}
        </tbody>
    );
};

export default TableBody;
